export const error = state => state.error
export const isLoading = state => state.isLoading
export const retrieved = state => state.retrieved
export const updated = state => state.updated
export const violations = state => state.violations
export const files = state => state.files



// WEBPACK FOOTER //
// ./src/store/modules/label/update/getters.js